import { DomUtil } from '@hugendubel/utils';
import { Globals } from '../globals';

const IFRAME_BODY_CLASS = 'in-iframe';
export const _LoyaltyIFrameService = {
    // we calculate this boolean on the private export to be able to modify it inside out tests
    insideIFrame: Globals.window() !== Globals.window().top,
};

const init = () => {
    if (_LoyaltyIFrameService.insideIFrame) {
        // we need to add this class to the body in order to adjust the body styles when inside an iFrame
        DomUtil.addBodyClass(IFRAME_BODY_CLASS);
    }
};

/**
 * This additional modal class will make the modal behave in different way to handle
 * the challenges of an modal inside of an iFrame.
 */
const modalClass = (): string => (_LoyaltyIFrameService.insideIFrame ? 'modal-iFrame' : '');

export const LoyaltyIFrameService = {
    init,
    modalClass,
    insideIFrame: () => _LoyaltyIFrameService.insideIFrame,
};
